import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
  saveStudentProgress,
  getStudentProgress,
  getSubjectProgress,
} from './ProgressApi';

export interface ISubTopicForProgress {
  _id: string;
  completion: number;
}

export interface ITopicForProgress {
  _id: string;
  subTopics: ISubTopicForProgress[];
}

export interface ISubjectForProgress {
  subject: string;
  subjectCode: string;
  subjectLevel: string;
  topics: ITopicForProgress[];
}

export interface IProgress {
  userId: string;
  subjects: ISubjectForProgress[];
}

export interface IProgressState {
  status: 'idle' | 'loading' | 'rejected';
  progress: IProgress;
  subjectProgress: ISubjectForProgress | undefined;
}

const initialState: IProgressState = {
  status: 'idle',
  progress: {
    userId: '',
    subjects: [],
  },
  subjectProgress: undefined,
};

export const ProgressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Save Progress
      .addCase(saveStudentProgress.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveStudentProgress.fulfilled, (state, action) => {
        state.status = 'idle';
        state.progress = action.payload;
      })
      .addCase(saveStudentProgress.rejected, (state) => {
        state.status = 'rejected';
      })

      // Get Progress
      .addCase(getStudentProgress.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getStudentProgress.fulfilled, (state, action) => {
        state.status = 'idle';
        state.progress = action.payload;
      })
      .addCase(getStudentProgress.rejected, (state) => {
        state.status = 'rejected';
      })

      // Get Subject Progress
      .addCase(getSubjectProgress.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getSubjectProgress.fulfilled, (state, action) => {
        state.status = 'idle';
        state.subjectProgress = action.payload;
      })
      .addCase(getSubjectProgress.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getProgressState = (state: RootState): RootState['progress'] =>
  state.progress;

export * from './ProgressApi';
export default ProgressSlice.reducer;
